module.exports = __webpack_public_path__ + "media/images/pc/stores/sapporo/sapporo_concept_02-c6bc76ab46b9a538a6fcedc5e52642ef.jpg";